<template>
  <b-container class="Section0" style="layout-grid:15.6000pt;">
    <h1>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-family:'Times New Roman';
font-weight:bold;font-size:24.0000pt;mso-font-kerning:22.0000pt;"
        >1</span>
      </b>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-family:'Times New Roman';
font-weight:bold;font-size:24.0000pt;mso-font-kerning:22.0000pt;"
        >
          <font face="宋体">数据的保密分级</font>
        </span>
      </b>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-family:'Times New Roman';
font-weight:bold;font-size:24.0000pt;mso-font-kerning:22.0000pt;"
        >
          <o:p></o:p>
        </span>
      </b>
    </h1>
    <p class="MsoNormal">
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">根据《</font>GB/T7156-1987
        <font face="宋体">文献保密等级代码》，将数据划分为</font>
        <font face="Calibri">6</font>
        <font face="宋体">个保密级别，分别为公开数据、国家内部数据、部门内部数据、秘密数据、机密数据、绝密数据。</font>
        <font face="Calibri"></font>
        <font face="宋体">（</font>
        <font face="Calibri">1</font>
        <font face="宋体">）公开数据</font>
        <font face="Calibri">∶</font>
        <font face="宋体">指数据可以向国外提供，可以进行国际交换。也就是可以提供国际范围共享的数据，该类数据主要包括那些国家间、地区间及国际机构相互交流、使用的数据。</font>
        <font face="Calibri"></font>
        <font face="宋体">（</font>
        <font face="Calibri">2</font>
        <font face="宋体">）国家内部数据</font>
        <font face="Calibri">∶</font>
        <font face="宋体">指数据可以在国内提供和交换。</font>
        <font face="Calibri"></font>
        <font face="宋体">（</font>
        <font face="Calibri">3</font>
        <font face="宋体">）部门内部数据</font>
        <font face="Calibri">∶</font>
        <font face="宋体">指数据可以在系统或系统某部门进行内部发行和交换。（</font>
        <font face="Calibri">4</font>
        <font face="宋体">）保密数据</font>
        <font face="Calibri">∶</font>
        <font face="宋体">指数据内容涉及国家一般秘密的数据。（</font>
        <font face="Calibri">5</font>
        <font face="宋体">）机密数据</font>
        <font face="Calibri">∶</font>
        <font face="宋体">指数据内容涉及国家重要秘密的数据。（</font>
        <font face="Calibri">6</font>
        <font face="宋体">）绝密数据</font>
        <font face="Calibri">∶</font>
        <font face="宋体">指数据内容涉及国家核心机密的数据。</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <h1>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-family:'Times New Roman';
font-weight:bold;font-size:24.0000pt;mso-font-kerning:22.0000pt;"
        >2</span>
      </b>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-family:'Times New Roman';
font-weight:bold;font-size:24.0000pt;mso-font-kerning:22.0000pt;"
        >
          <font face="宋体">数据共享和保密</font>
        </span>
      </b>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-family:'Times New Roman';
font-weight:bold;font-size:24.0000pt;mso-font-kerning:22.0000pt;"
        >
          <o:p></o:p>
        </span>
      </b>
    </h1>
    <p class="MsoNormal" style="text-indent:30.0000pt;mso-char-indent-count:2.0000;">
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">数据</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">共享的目的是保证不同保密级别的数据在不同的范围内得到安全的数据共享服务。例如部门内部数据是在部门内部共享的，在部门以外应该是绝对保密的不可见的。</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">凝聚态物质科</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">学数据</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">中心</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">共享的</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">主要</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">是公开数据。从数据的角度，分为两种数据，一种是数据本身，一种是描述数据的数据。在</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">数据中心</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">内，描述数据的数据应该都属于公开数据，而数据则有密级之分。</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <h1>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-family:'Times New Roman';
font-weight:bold;font-size:24.0000pt;mso-font-kerning:22.0000pt;"
        >3</span>
      </b>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-family:'Times New Roman';
font-weight:bold;font-size:24.0000pt;mso-font-kerning:22.0000pt;"
        >
          <font face="宋体">数据的安全管理</font>
        </span>
      </b>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-family:'Times New Roman';
font-weight:bold;font-size:24.0000pt;mso-font-kerning:22.0000pt;"
        >
          <o:p></o:p>
        </span>
      </b>
    </h1>
    <p class="MsoNormal" style="text-indent:15.0000pt;mso-char-indent-count:1.0000;">
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <font
          face="宋体"
        >现代信息系统的安全管理既是一个复杂的技术问题，也是一项要求严格的管理规范。信息系统是一种内容繁多、结构复杂、环境多变的人机系统，要想有效地保护信息系统的安全，必须从信息安全技术、组织机构与人事管理、信息安全法制建设等方面采取综合治理措施。</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal" style="text-indent:15.0000pt;mso-char-indent-count:1.0000;">
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p>&nbsp;</o:p>
      </span>
    </p>
    <p class="MsoNormal" style="text-indent:16.0500pt;mso-char-indent-count:1.0000;">
      <b>
        <span
          class="15"
          style="mso-spacerun:'yes';font-family:黑体;mso-ascii-font-family:Arial;
mso-hansi-font-family:Arial;font-weight:bold;font-size:16.0000pt;"
        >3.1</span>
      </b>
      <b>
        <span
          class="15"
          style="mso-spacerun:'yes';font-family:Arial;mso-fareast-font-family:黑体;
font-weight:bold;font-size:16.0000pt;"
        >
          <font face="黑体">技术管理</font>
        </span>
      </b>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      ></span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal" style="text-indent:16.0500pt;mso-char-indent-count:1.0000;">
      <b>
        <span
          class="16"
          style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:16.0000pt;"
        >3.1.1</span>
      </b>
      <b>
        <span
          class="16"
          style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:16.0000pt;"
        >
          <font face="宋体">硬件环境安全管理</font>
        </span>
      </b>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"
      ></span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal" style="text-indent:30.0000pt;mso-char-indent-count:2.0000;">
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">机房环境管理</font>∶
        <font
          face="宋体"
        >为保证机房内所有设备的安全、稳定、无故障运行，监控机房的环境、监测并定期检查电源、通风、接地等所有机房设施的工作状态，发现并报告问题和提出变更建议，应考虑机房内通风、温度、湿度、灰尘、灯光等的配置</font>
        <font face="Calibri">;</font>
        <font face="宋体">考虑设备放置与冷却效率和制冷单元热点的关系</font>
        <font face="Calibri">;</font>
        <font face="宋体">以及可能因功能扩大引起的冷却效率问题，设备之间的干扰等问题。</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal" style="text-indent:15.0000pt;mso-char-indent-count:1.0000;">
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">电源管理</font>∶
        <font face="宋体">将电源有效分配到系统中不同的设备组件，保持各设备的电源供给稳定。应考虑电源设备参数对设备的影响，如过压、过流、浪涌、短路、杂波干扰等。</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal" style="text-indent:15.0000pt;mso-char-indent-count:1.0000;">
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">服务器设备管理</font>∶
        <font
          face="宋体"
        >计算机信息系统设备的日常运行和管理、可靠性评价，须定期监测设备的使用情况，不定期进行效能优化处理。考虑不同的设备的散热、电磁干扰、电压电流等因素的相互影响。系统中的关键部分满足冗余配置。</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal" style="text-indent:15.0000pt;mso-char-indent-count:1.0000;">
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">网络设备管理</font>∶
        <font face="宋体">网络设备是数据传输的通道，交换机、路由器等网络设备需要具备一定的网络安全管理功能，如</font>
        <font face="Calibri">IP</font>
        <font face="宋体">控制、</font>
        <font face="Calibri">ARP</font>
        <font face="宋体">防护等，重要节点和重要数据的网络设备应带有防火墙功能。</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal" style="text-indent:15.0000pt;mso-char-indent-count:1.0000;">
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">布线系统管理和维护</font>∶
        <font
          face="宋体"
        >监控、诊断、分析设备间、弱电井等区域配线设备、线缆、信息插座等设施，及网络通信线路的工作状态和可能的故障状态，发现并报告问题，提出维护建议，保证系统运行的高可靠性和维护的高效率。</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal" style="text-indent:15.0000pt;mso-char-indent-count:1.0000;">
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">监控系统管理和维护</font>∶
        <font
          face="宋体"
        >监控、诊断、分析门禁系统、各类监控设备等的运行状态、参数变化、提示信息等，发现并报告问题，及时变更、维护，保证监控系统的可靠性。机房电源环境要做到防火、防水、防雷、安全用电和烟雾探测报警。</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal" style="text-indent:15.0000pt;mso-char-indent-count:1.0000;">
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">应急管理</font>∶
        <font face="宋体">主要应对突发事件。电源方面，应配备大型</font>
        <font face="Calibri">UPS</font>
        <font face="宋体">电源，保证应</font>
        <font face="Calibri">│</font>
        <font
          face="宋体"
        >急期间服务器等设备的的不间断供电。服务器设备方面，应具有备份系统，备份服务器的数据应尽量与主服务器上的尽量保持一致。在应急时自动启动。环境方面，配备应急照明设备，配备安装机房监控系统作为保障。对配电系统、环境系统、消防系统、保安系统、网络系统进行监测、监视、报警。</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal" style="text-indent:15.0000pt;mso-char-indent-count:1.0000;">
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">日常检修管理</font>∶
        <font face="宋体">对于机房环境和各种设备应有专人负责定期检修，及时排除隐患。</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal" style="text-indent:15.0000pt;mso-char-indent-count:1.0000;">
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">原则上硬件安全配置上应满足《</font>GB/T2239-2008
        <font face="宋体">信息安全技术 信息系统安全等级保护基本要求》第三级物理安全的技术要求。</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal" style="text-indent:15.0000pt;mso-char-indent-count:1.0000;">
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p>&nbsp;</o:p>
      </span>
    </p>
    <h3>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-weight:bold;
font-size:16.0000pt;mso-font-kerning:1.0000pt;"
        >3.1.2</span>
      </b>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-weight:bold;font-size:16.0000pt;
mso-font-kerning:1.0000pt;"
        >
          <font face="宋体">软件安全管理操作系统</font>
        </span>
      </b>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-weight:bold;font-size:16.0000pt;
mso-font-kerning:1.0000pt;"
        >
          <o:p></o:p>
        </span>
      </b>
    </h3>
    <p class="MsoNormal" style="text-indent:15.0000pt;mso-char-indent-count:1.0000;">
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <font
          face="宋体"
        >操作系统属于底层支撑系统，是共享网运行的软件环境的基础，要求由专门的管理人员来维护，安装稳定高的的操作系统，进行必要的操作系统的安全配置，定期对系统进行升级、修补系统漏洞，监测和优化操作系统与数据库系统及其他应用软件的工作效能。操作系统的用户帐号和使用人数应有严格控制，设置系统控制参数和系统运行监视，同时用户的操作必须有详细的日志记录，定期备份日志。严禁非业务用软件的运行和拷贝。</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal" style="text-indent:15.0000pt;mso-char-indent-count:1.0000;">
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">数据库</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal" style="text-indent:15.0000pt;mso-char-indent-count:1.0000;">
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">数据中心</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <font
          face="宋体"
        >的各节点应尽量采用成熟的大型数据库管理系统，数据库的管理采用分布式结构管理，并严格遵循国际开放标准和规范。对数据库用户的的权限进行严格限制，要求配备专门的数据库管理人员，定期对数据库进行必要的监测和优化，提高检索速度，完善备份恢复策略，同时详细记录操作日志。</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal" style="text-indent:15.0000pt;mso-char-indent-count:1.0000;">
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">网站</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal" style="text-indent:15.0000pt;mso-char-indent-count:1.0000;">
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <font
          face="宋体"
        >共享中心以及各个子节点的站点向用户提供服务，要求配置有相应的维护人员，各站点要求留有站点的负责方的联系方式，网站服务出现异常时，维护人员应能及时排除故障，恢复网站的正常运行。各网站在网络的数据安全方面应采用数据加密、数字签名、数字证书及内容防篡改等技术，防止敏感数据被非法访问、修改和破坏，保证数据的完整性。</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal" style="text-indent:15.0000pt;mso-char-indent-count:1.0000;">
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">其它应用软件</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal" style="text-indent:15.0000pt;mso-char-indent-count:1.0000;">
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">应用软件是数据共享系统的支撑平台，涉及种类很多，包括</font> Web Service
        <font
          face="宋体"
        >、数据处理等，也涉及到多个厂商的技术支持。对于这些软件的维护和管理须分门别类来进行，建立相应的维护流程，保证应用软件的可靠、高效运行。采用适当的加密防护措施、数据备份措施、防病毒措施及防火墙技术，并定期升级更新相关软件，确保所使用网络安全防护软件为最新版本。</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal" style="text-indent:15.0000pt;mso-char-indent-count:1.0000;">
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">在软件配置上，非涉密系统网络基础设施建设应符合《</font>GB/T 20270-2006
        <font face="宋体">信息安全技术 网络基础安全技术要求》</font>
        <font face="Calibri">;</font>
        <font face="宋体">涉及国家机密、部门敏感信息的局域网的安全标准不得低于《</font>
        <font face="Calibri">GB17859-1999</font>
        <font face="宋体">计算机信息系统安全保护等级划分准则》中规定的第二级一系统审计保护级。</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <h2>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:黑体;mso-ascii-font-family:Arial;
mso-hansi-font-family:Arial;mso-bidi-font-family:'Times New Roman';font-weight:bold;
font-size:16.0000pt;mso-font-kerning:1.0000pt;"
        >3.</span>
      </b>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:Arial;mso-fareast-font-family:黑体;
mso-bidi-font-family:'Times New Roman';font-weight:bold;font-size:16.0000pt;
mso-font-kerning:1.0000pt;"
        >
          2
          <font face="黑体">组织管理</font>
        </span>
      </b>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:Arial;mso-fareast-font-family:黑体;
mso-bidi-font-family:'Times New Roman';font-weight:bold;font-size:16.0000pt;
mso-font-kerning:1.0000pt;"
        >
          <o:p></o:p>
        </span>
      </b>
    </h2>
    <p class="MsoNormal" style="text-indent:15.0000pt;mso-char-indent-count:1.0000;">
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <font
          face="宋体"
        >以数据安全为重点，统一规划，建立信息安全认证体系、运行环境的安全保障系统和功能完备的容灾备份系统，确保数据中心的物理安全、网络安全、系统安全和数据安全。所有汇交的数据资料应严格按照有关数据资料管理规定进行分类存档管理</font>;
        <font face="宋体">应设立信息安全管理工作的职能部门，配备专职安全管理员，负责数据中心数据安全工作，并与关键岗位人员签署岗位安全协议和保密协议</font>
        <font face="Calibri">;</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <h2>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:黑体;mso-ascii-font-family:Arial;
mso-hansi-font-family:Arial;mso-bidi-font-family:'Times New Roman';font-weight:bold;
font-size:16.0000pt;mso-font-kerning:1.0000pt;"
        >3</span>
      </b>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:Arial;mso-fareast-font-family:黑体;
mso-bidi-font-family:'Times New Roman';font-weight:bold;font-size:16.0000pt;
mso-font-kerning:1.0000pt;"
        >
          .3
          <font face="黑体">法制管理</font>
        </span>
      </b>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:Arial;mso-fareast-font-family:黑体;
mso-bidi-font-family:'Times New Roman';font-weight:bold;font-size:16.0000pt;
mso-font-kerning:1.0000pt;"
        >
          <o:p></o:p>
        </span>
      </b>
    </h2>
    <p class="MsoNormal" style="text-indent:15.0000pt;mso-char-indent-count:1.0000;">
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">根据国家保密有关法律法规，组织完成数据安全定级工作，明确制度、分清职责、分级管理、逐级落实</font>;
        <font face="宋体">在数据资源终止阶段，对于数据转移、暂存和清除、设备迁移或废弃、存储介质的清除或销毁等活动须按照《</font>
        <font face="Calibri">GB/T XXXXX-XXXX</font>
        <font face="宋体">信息安全技术 信息系统安全等级保护实施指南》的要求执行，如果是涉密数据，应该按照国家相关部门的规定进行转移、暂存和清除</font>
        <font face="Calibri">;</font>
        <font face="宋体">涉密数据资料的存储、传输、共享、使用应指定专人负责，并严格按照国家有关保密的法律、法规执行。</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal" style="text-indent:15.0000pt;mso-char-indent-count:1.0000;">
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p>&nbsp;</o:p>
      </span>
    </p>
    <p class="MsoNormal" style="text-indent:15.0000pt;mso-char-indent-count:1.0000;">
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p>&nbsp;</o:p>
      </span>
    </p>
    <h1>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-family:'Times New Roman';
font-weight:bold;font-size:24.0000pt;mso-font-kerning:22.0000pt;"
        >4 数据汇交</span>
      </b>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-family:'Times New Roman';
font-weight:bold;font-size:24.0000pt;mso-font-kerning:22.0000pt;"
        >
          <o:p></o:p>
        </span>
      </b>
    </h1>
    <h2>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:黑体;mso-ascii-font-family:Arial;
mso-hansi-font-family:Arial;mso-bidi-font-family:'Times New Roman';font-weight:bold;
font-size:16.0000pt;mso-font-kerning:1.0000pt;"
        >
          4.1
          <font face="黑体">数据汇交流程</font>
        </span>
      </b>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:Arial;mso-fareast-font-family:黑体;
mso-bidi-font-family:'Times New Roman';font-weight:bold;font-size:16.0000pt;
mso-font-kerning:1.0000pt;"
        >
          <o:p></o:p>
        </span>
      </b>
    </h2>
    <p class="MsoNormal" style="text-indent:15.0000pt;mso-char-indent-count:1.0000;">
      <img width="554" height="290" src="../assets/data_2767.png" />
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p>&nbsp;</o:p>
      </span>
    </p>
    <h2>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:黑体;mso-ascii-font-family:Arial;
mso-hansi-font-family:Arial;mso-bidi-font-family:'Times New Roman';font-weight:bold;
font-size:16.0000pt;mso-font-kerning:1.0000pt;"
        >
          4.2
          <font face="黑体">数据汇交目的</font>
        </span>
      </b>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:Arial;mso-fareast-font-family:黑体;
mso-bidi-font-family:'Times New Roman';font-weight:bold;font-size:16.0000pt;
mso-font-kerning:1.0000pt;"
        >
          <o:p></o:p>
        </span>
      </b>
    </h2>
    <p class="MsoNormal" style="text-indent:15.0000pt;mso-char-indent-count:1.0000;">
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">规范科学数据汇交，进一步加强和规业科学数据管理，保障科学数据安全，提高开放共享水平，更好支撑国家科技创新、经济社会发展和国家安全。</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <h2>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:黑体;mso-ascii-font-family:Arial;
mso-hansi-font-family:Arial;mso-bidi-font-family:'Times New Roman';font-weight:bold;
font-size:16.0000pt;mso-font-kerning:1.0000pt;"
        >
          4.3
          <font face="黑体">数据汇交依据</font>
        </span>
      </b>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:Arial;mso-fareast-font-family:黑体;
mso-bidi-font-family:'Times New Roman';font-weight:bold;font-size:16.0000pt;
mso-font-kerning:1.0000pt;"
        >
          <o:p></o:p>
        </span>
      </b>
    </h2>
    <p class="MsoNormal" style="text-indent:15.0000pt;mso-char-indent-count:1.0000;">
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        2018
        <font face="宋体">年</font>
        <font face="Calibri">2</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">月</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >13</span>
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">日，科技部、财政部印发的《国家科技资源共享服务平台管理办法》；</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal" style="text-indent:15.0000pt;mso-char-indent-count:1.0000;">
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >2018</span>
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">年</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >3</span>
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">月</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >17</span>
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">日，国务院办公厅出台的《科学数据管理办法》；</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal" style="text-indent:15.0000pt;mso-char-indent-count:1.0000;">
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >2019</span>
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">年</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >6</span>
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">月</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >11</span>
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">日，国中共中央办公厅、国务院办公厅印发《关于进一步弘扬科学家精神加强作风和学风建设的意见》。</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal" style="text-indent:15.0000pt;mso-char-indent-count:1.0000;">
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p>&nbsp;</o:p>
      </span>
    </p>
    <h2>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:黑体;mso-ascii-font-family:Arial;
mso-hansi-font-family:Arial;mso-bidi-font-family:'Times New Roman';font-weight:bold;
font-size:16.0000pt;mso-font-kerning:1.0000pt;"
        >
          4.4
          <font face="黑体">数据汇交意义</font>
        </span>
      </b>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:Arial;mso-fareast-font-family:黑体;
mso-bidi-font-family:'Times New Roman';font-weight:bold;font-size:16.0000pt;
mso-font-kerning:1.0000pt;"
        >
          <o:p></o:p>
        </span>
      </b>
    </h2>
    <p class="MsoNormal" style="text-indent:15.0000pt;mso-char-indent-count:1.0000;">
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        1
        <font face="宋体">、响应国家政策要求</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal" style="text-indent:15.0000pt;mso-char-indent-count:1.0000;">
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >2018</span>
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">年国家出台《科学数据管理办法》和《国家科技资源共享服务平台管理办法》两个文件，突出科学数据</font>“开放为常态，不开放为例外”的共享理念，特别指出政府预算资金资助的各级科技计划（专项、基金等）项目所形成的科学数据，应由项目牵头单位汇交到相关科学数据中心。并要求各级科技计划（专项、基金等）管理部门应建立先汇交科学数据、再验收科技计划（专项、基金等）项目的机制；项目
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >/</span>
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">课题验收后产生的科学数据也应进行汇交。</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p
      class="MsoNormal"
      style="text-indent:15.0000pt;mso-char-indent-count:1.0000;mso-list:l0 level1 lfo1;"
    >
      <!--[if !supportLists]-->

      <span
        style="font-family:宋体;mso-ascii-font-family:Calibri;mso-hansi-font-family:Calibri;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <span style="mso-list:Ignore;">2、</span>
      </span>
      <!--[endif]-->
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">弥补基础研究短板</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal" style="text-indent:15.0000pt;mso-char-indent-count:1.0000;">
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font
          face="宋体"
        >科学数据是国家重要的基础性战略资源，科技创新依赖于大量、系统、高可信度的科学数据，海量科学数据的共享和应用对基础学科的发展会产生重大影响。汇交科学数据，并通过科学数据中心进行规范管理和长期保存，有利于发挥国家财政投入产出效益，提高我科技创新、经济社会发展和国家安全支撑保障能力。</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal" style="text-indent:15.0000pt;mso-char-indent-count:1.0000;">
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >3</span>
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">、加快科学数据增值</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal" style="text-indent:15.0000pt;mso-char-indent-count:1.0000;">
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font
          face="宋体"
        >国家科学数据中心面向建设科技强国的战略需求，解决领域科学数据分散的问题，通过国家科学数据中心对社会提供科学数据共享服务，可以促进科学数据的有效流转和利用，通过多种数据融合和深入数据挖掘分析，能够有效促进数据增值，推动科学研究和科技成果产出、提高数据创建者和持有者的影响力。</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <h2>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:黑体;mso-ascii-font-family:Arial;
mso-hansi-font-family:Arial;mso-bidi-font-family:'Times New Roman';font-weight:bold;
font-size:16.0000pt;mso-font-kerning:1.0000pt;"
        >4.5</span>
      </b>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:Arial;mso-fareast-font-family:黑体;
mso-bidi-font-family:'Times New Roman';font-weight:bold;font-size:16.0000pt;
mso-font-kerning:1.0000pt;"
        >
          <font face="黑体">汇</font>
        </span>
      </b>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:黑体;mso-ascii-font-family:Arial;
mso-hansi-font-family:Arial;mso-bidi-font-family:'Times New Roman';font-weight:bold;
font-size:16.0000pt;mso-font-kerning:1.0000pt;"
        >
          <font face="黑体">交数据范围</font>
        </span>
      </b>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:Arial;mso-fareast-font-family:黑体;
mso-bidi-font-family:'Times New Roman';font-weight:bold;font-size:16.0000pt;
mso-font-kerning:1.0000pt;"
        >
          <o:p></o:p>
        </span>
      </b>
    </h2>
    <p class="MsoNormal" style="text-indent:15.0000pt;mso-char-indent-count:1.0000;">
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">汇</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font
          face="宋体"
        >交的科学数据范围包括国家政府性资金支持的科技活动所形的相关科学数据、合作机构根据特定需求加工的相关科学数据、机构和个人产出的科学数据（如论文相关数据），以及相关的辅助科学数据和工具软件等。</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal">
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">实验</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">和</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">测量</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">数据：</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">来着实验的观察和测量数据。</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal">
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">计算和模拟数据：</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">来自计算模型或模拟的数据。</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal">
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">分析数据</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">：通过分析、挖掘和二次开发得到的数据资源。</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <h2>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:黑体;mso-ascii-font-family:Arial;
mso-hansi-font-family:Arial;mso-bidi-font-family:'Times New Roman';font-weight:bold;
font-size:16.0000pt;mso-font-kerning:1.0000pt;"
        >
          4.6
          <font face="黑体">汇交后的管理</font>
        </span>
      </b>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:Arial;mso-fareast-font-family:黑体;
mso-bidi-font-family:'Times New Roman';font-weight:bold;font-size:16.0000pt;
mso-font-kerning:1.0000pt;"
        >
          <o:p></o:p>
        </span>
      </b>
    </h2>
    <p class="MsoNormal">
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <br />
      </span>
      <b>
        <span
          class="16"
          style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:16.0000pt;"
        >
          4.6.1
          <font face="宋体">数据审核</font>
        </span>
      </b>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal">
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">凝聚态物质科学数据中心对汇交的科学数据审核的事项主要包括以下几个方面：</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal">
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">（</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >1</span>
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">）汇交的科学数据是否齐全；</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal">
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">（</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >2</span>
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">）汇交的科学数据是否符合形式要求；</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal">
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">（</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >3</span>
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">）汇交的科学数据是否符合保密要求；</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal">
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">（</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >4</span>
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">）汇交的科学数据是否符合规定的质量要求；</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal">
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">（</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >5</span>
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">）汇交的科学数据是否符合无敏感信息的要求；</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal">
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">（</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >6</span>
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">）汇交的科学数据是否符合无伦理问题的要求；</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal">
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">（</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >7</span>
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">）项目数据汇交计划的执行情况和是否符合项目数据汇交指标；</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal">
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">（</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >8</span>
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">）汇交的科学数据是否具有科学价值和使用价值等。</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal">
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >&nbsp;</span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <h2>
      <span
        class="16"
        style="mso-spacerun:'yes';font-family:宋体;font-weight:normal;
font-size:16.0000pt;"
      >4.6.2</span>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:黑体;mso-ascii-font-family:Arial;
mso-hansi-font-family:Arial;mso-bidi-font-family:'Times New Roman';font-weight:bold;
font-size:16.0000pt;mso-font-kerning:1.0000pt;"
        >
          <font face="黑体">数据管理</font>
        </span>
      </b>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:Arial;mso-fareast-font-family:黑体;
mso-bidi-font-family:'Times New Roman';font-weight:bold;font-size:16.0000pt;
mso-font-kerning:1.0000pt;"
        >
          <o:p></o:p>
        </span>
      </b>
    </h2>
    <p class="MsoNormal">
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font
          face="宋体"
        >依据《国家科学数据管理办法》和科学数据中心的数据政策和技术规定，组织对汇交的科学数据进行分类、标注、整理和安全存储等全生命周期管理，面向行业和社会，提供不同层次、不同权限的数据共享使用服务，注明数据来源，并遵守知识产权相关的法规及数据汇交时所附加的使用条件。</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal">
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >&nbsp;</span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <h3>
      <span
        class="16"
        style="mso-spacerun:'yes';font-family:宋体;font-weight:normal;
font-size:16.0000pt;"
      >4.6.3</span>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-weight:bold;
font-size:16.0000pt;mso-font-kerning:1.0000pt;"
        >
          <font face="宋体">数据保藏</font>
        </span>
      </b>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-weight:bold;font-size:16.0000pt;
mso-font-kerning:1.0000pt;"
        >
          <o:p></o:p>
        </span>
      </b>
    </h3>
    <p class="MsoNormal">
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">科学数据汇交人、汇交人所在单位在数据汇集、呈交、审核科学数据的过程中，负有妥善保管科学数据的义务。</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal">
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">国家科学数据中心按国家相关法律法规要求保藏汇交的科学数据。</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal">
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">随着数据保藏介质和设备的更新，国家科学数据中心将采取相应的应对措施，保障汇交的科学数据不因技术发展而出现遗失并得到永久保藏。</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal">
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">依据国家秘密法属于国家秘密的科学数据应当采取特殊的保管措施。</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal">
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >&nbsp;</span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <h3>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-weight:bold;
font-size:16.0000pt;mso-font-kerning:1.0000pt;"
        >
          4.6.4
          <font face="宋体">数据保密</font>
        </span>
      </b>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-weight:bold;font-size:16.0000pt;
mso-font-kerning:1.0000pt;"
        >
          <o:p></o:p>
        </span>
      </b>
    </h3>
    <p class="MsoNormal">
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">涉及国家安全、国家秘密的国家科学数据，其密级的确定、变更和解密，以及汇交传递、存储和使用，依照有关国家安全和保守国家秘密的规定执行。</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <h3>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-weight:bold;font-size:16.0000pt;
mso-font-kerning:1.0000pt;"
        >&nbsp;</span>
      </b>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-weight:bold;font-size:16.0000pt;
mso-font-kerning:1.0000pt;"
        >
          <o:p></o:p>
        </span>
      </b>
    </h3>
    <h3>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-weight:bold;
font-size:16.0000pt;mso-font-kerning:1.0000pt;"
        >
          4.6.5
          <font face="宋体">数据撤销</font>
        </span>
      </b>
      <b>
        <span
          style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-weight:bold;font-size:16.0000pt;
mso-font-kerning:1.0000pt;"
        >
          <o:p></o:p>
        </span>
      </b>
    </h3>
    <p class="MsoNormal">
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">（</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >1</span>
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">）汇交人申请数据撤销</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal">
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">出于某些特殊原因，数据汇交人（非项目数据汇交负责人）可提出已汇交数据的撤销申请，凝聚态物质科学数据中心评定是否予以撤销。</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal">
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">已汇交的项目数据提出撤销申请的，需出具主管部门提供的准予撤销证明文件。</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal">
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">（</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >2</span>
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font face="宋体">）凝聚态物质科学数据中心提出的撤销数据</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal">
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <font
          face="宋体"
        >在科学数据中心注册后的科学数据资源，一经发现并经查实存在弄虚作假、违反相关法律法规要求的情况时，科学数据中心将撤销其注册资格，并在汇交网站予以通报。同时撤销其唯一性标识、证书等证明文件。</font>
      </span>
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
    <p class="MsoNormal" style="text-indent:0.0000pt;mso-char-indent-count:0.0000;">
      <span
        style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;mso-font-kerning:1.0000pt;"
      >&nbsp;</span>
      <span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:15.0000pt;
mso-font-kerning:1.0000pt;"
      >
        <o:p></o:p>
      </span>
    </p>
  </b-container>
</template>

<script>
import Building from "./Building.vue";
export default {
  name: "Help",

  components: {
    Building
  },

  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
